import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=77ad4674&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=77ad4674&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ad4674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ad4674')) {
      api.createRecord('77ad4674', component.options)
    } else {
      api.reload('77ad4674', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=77ad4674&scoped=true", function () {
      api.rerender('77ad4674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/financial/wallets/Index.vue"
export default component.exports